var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Mixpanel } from "@/utilities/mixpanel/Mixpanel";
import useAdminStore from "@/services/store/useAdminStore";
var useSuccessResponseHandler = function () {
    var adminNotification = useAdminStore().adminNotification;
    return function (notification, mixpanelMessage, mixpanelPayload) {
        if (mixpanelMessage) {
            Mixpanel === null || Mixpanel === void 0 ? void 0 : Mixpanel.track({
                name: mixpanelMessage,
                props: {
                    type: "event",
                    payload: mixpanelPayload || undefined,
                },
            });
        }
        if (notification) {
            adminNotification.add(__assign(__assign({}, notification), { message: notification.message, type: adminNotification.types.SUCCESS }));
        }
    };
};
export default useSuccessResponseHandler;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU3VjY2Vzc1Jlc3BvbnNlSGFuZGxlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZVN1Y2Nlc3NSZXNwb25zZUhhbmRsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFDekQsT0FBTyxhQUFhLE1BQU0sZ0NBQWdDLENBQUM7QUFHM0QsSUFBTSx5QkFBeUIsR0FBRztJQUN4QixJQUFBLGlCQUFpQixHQUFLLGFBQWEsRUFBRSxrQkFBcEIsQ0FBcUI7SUFFOUMsT0FBTyxVQUNMLFlBQTZDLEVBQzdDLGVBQThCLEVBQzlCLGVBQXFCO1FBRXJCLElBQUksZUFBZSxFQUFFO1lBQ25CLFFBQVEsYUFBUixRQUFRLHVCQUFSLFFBQVEsQ0FBRSxLQUFLLENBQUM7Z0JBQ2QsSUFBSSxFQUFFLGVBQWU7Z0JBQ3JCLEtBQUssRUFBRTtvQkFDTCxJQUFJLEVBQUUsT0FBTztvQkFDYixPQUFPLEVBQUUsZUFBZSxJQUFJLFNBQVM7aUJBQ3RDO2FBQ0YsQ0FBQyxDQUFDO1NBQ0o7UUFFRCxJQUFJLFlBQVksRUFBRTtZQUNoQixpQkFBaUIsQ0FBQyxHQUFHLHVCQUNoQixZQUFZLEtBQ2YsT0FBTyxFQUFFLFlBQVksQ0FBQyxPQUFPLEVBQzdCLElBQUksRUFBRSxpQkFBaUIsQ0FBQyxLQUFLLENBQUMsT0FBTyxJQUNyQyxDQUFDO1NBQ0o7SUFDSCxDQUFDLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLHlCQUF5QixDQUFDIn0=